import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'citySize'
})
export class CitySizePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    if (!value) {
      return value;
    }

    const index = value.indexOf(' ');

    if (index === -1) {
      return value; // 공백이 없으면 원래 문자열을 반환
    }

    const firstPart = value.substring(0, index);
    const secondPart = value.substring(index + 1);

    return `${firstPart}&nbsp;<span class="size-90">${secondPart}</span>`;
  }

}
